import { useContext, createContext } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const PermissionContext = createContext()

const PermissionProvider = ({ children }) => {

    const { headers, toast, restaurantId } = useAuth();

    const getAllPermissions = async () => {
        try {
            let { data } = await axios.get(`${baseURL}/permissions?restaurant_id=${restaurantId}`, { headers })
            if (data.error === false) {
                return data.data
            }
        } catch (error) {
            toast.current?.show({ severity: 'error', summary: 'Permission', detail: error?.response?.data?.message, life: 3000 })
        }
    }
  
    const updatePermissions = async (groups) => {
        try {            
            let { data } = await axios.post(`${baseURL}/permissions?restaurant_id=${restaurantId}`, { groups }, { headers })
            if (data.error === false) {
                setTimeout(function () {
                    toast.current?.show({ severity: 'success', summary: 'Permission', detail: data.message, life: 3000 })
                }, 500);
                return data.data;
            } else {
                toast.current?.show({ severity: 'error', summary: 'Permission', detail: data.message, life: 3000 })
            }
        } catch (error) {
            console.log(error);
            toast.current?.show({ severity: 'error', summary: 'Permission', detail: error?.response?.data?.message, life: 3000 }) 
        }
    }

    return (
        <PermissionContext.Provider value={{ getAllPermissions, updatePermissions }}>
            {children}
        </PermissionContext.Provider>
    )
}

const usePermission = () => useContext(PermissionContext)

export { usePermission, PermissionProvider, }